import { Schema } from "effect";
export const PaginationSearchParams = Schema.Struct({
    after: Schema.Number.pipe(Schema.NullOr),
    limit: Schema.Number
});
export const Pagination = Schema.Union(Schema.Struct({
    hasMore: Schema.Literal(true),
    cursor: Schema.String
}), Schema.Struct({
    hasMore: Schema.Literal(false),
    cursor: Schema.Null
}));
